// extracted by mini-css-extract-plugin
export default {"modalRequestError":"ni2OV","modalErrorText":"uzykT"};